import React, {useContext, useEffect, useState} from "react";
// @ts-ignore
import {useHistory, useLocation} from "react-router-dom";

import Images from "../../assets/images/Images";
import Colors from "../../assets/colors/Colors";
import {FlexedDiv} from "../styledComponents/CustomStyledComponents";
import Constants from "../../data/Constants";
import ContentRankingComponent from "./Components/ContentRankingComponent";
import YearReportComponent from "./Components/YearReportComponent";
import {RankingsAndLevelsContext} from "../../contexts/RankingsAndLevelsContext";
import RankingsAndLevelsUtils from "../../services/RankingsAndLevelsUtils";

import './RankingsAndLevels.css'
import BackComponentWrapper from "./Components/BackComponentWrapper";
import styled from "styled-components";

const baseUrl = Constants.routes.rankings;


interface Props {
    bkgColor: string,
    bkgImg: string,
    fontColor: string,
}

const RankingsContainerDiv = styled.div`
    height: 100%;
    flex: 1;
    display: flex;
    background-position: center center;
    background-repeat: no-repeat;
    background-attachment: fixed;

    background-color: ${(props: Props) => props.bkgColor};
    background-image: url(${(props: Props) => props.bkgImg});

    * {
        color: ${(props: Props) => props.fontColor};
    }
`;

const RankingsAndLevelsComponent: React.FC = () => {
    let history = useHistory();
    let location = useLocation();
    //@ts-ignore
    const {isLife, setIsLife} = useContext(RankingsAndLevelsContext);

    const [tabSelected, setTabSelected] = useState(RankingsAndLevelsUtils.lifeValues.life);
    const lifeValues = RankingsAndLevelsUtils.lifeValues;

    useEffect(() => {
        const querySearch = location.search.match(/life=[^&]*&?/);
        if(querySearch && querySearch[0]){
            let lifeValue = (querySearch[0] === `life=${lifeValues.life}`) ? lifeValues.life : lifeValues.noLife;

            if(!isLife && lifeValue === lifeValues.life){
                handleTabSelection(lifeValues.life);
                history.push(`${baseUrl}?life=${lifeValues.life}`)
            }
            if(isLife && lifeValue === lifeValues.noLife){
                handleTabSelection(lifeValues.noLife);
                history.push(`${baseUrl}?life=${lifeValues.noLife}`)
            }
        } else {
            handleTabSelection(lifeValues.life);
        }
    }, []);


    const handleTabSelection = (id: number) => {
        setTabSelected(id);
        switch (id) {
            case lifeValues.life:
                history.push(`${Constants.routes.rankings}?life=0`);
                setIsLife(true);
                break;
            case lifeValues.noLife:
                history.push(`${Constants.routes.rankings}?life=1`);
                setIsLife(false);
                break;
            default:
                break;
        }
    };

    return (
        <RankingsContainerDiv
            bkgColor={isLife ? Colors.backgroundGray: Colors.backgroundWhite}
            bkgImg={isLife ? Images.mapBackgroundLife : Images.mapBackgroundNoLife}
            fontColor={isLife ? Colors.fontWhite : Colors.fontGray}
        >
            <BackComponentWrapper />
            <ContentRankingComponent tabSelected={tabSelected} handleTabSelection={handleTabSelection}/>
            <FlexedDiv flexValue={1}/>
            <YearReportComponent />
        </RankingsContainerDiv>
    )
};

export default RankingsAndLevelsComponent;
